import type React from 'react';

interface Props {
  text: string;
}

const SimpleFormat: React.FC<Props> = ({ text }) => (
  <div
    style={{
      whiteSpace: 'pre-wrap',
      lineHeight: '1.5',
      wordWrap: 'break-word',
    }}
  >
    {text}
  </div>
);

export default SimpleFormat;
